import React from "react"
import { Link as GatsbyLink } from "gatsby"

// Explicity name props that aren’t supported in the DOM
// (i.e. `contrastText`) and then pass other props to link.
// This avoids warnings regarding unsupported attributes
// when rendering the link
const Link = ({contrastText, openInNewWindow, ...props}) => {
  
  // Since DOM elements <a> cannot receive activeClassName
  // and partiallyActive, destructure the prop here and
  // pass it only to GatsbyLink
  const {
    to,
    children,
    activeClassName,
    partiallyActive,
    rel = "noopener noreferrer",
    ...linkProps
  } = props

  const internal = /^\/(?!\/)/.test(to)
  const file = /\.[0-9a-z]+$/i.test(to)

  if (internal && !file && !openInNewWindow) {
    return (
      <GatsbyLink {...props}>
        {children}
      </GatsbyLink>
    )
  } else {
    return (
      // eslint-disable-next-line react/jsx-no-target-blank
      <a href={to} rel={rel} target={openInNewWindow ? "_blank" : linkProps.target} {...linkProps}>
        {children}
      </a>
    )
  }
}

export default Link
